import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { themeConfig } from '@gap/shared/theme'
import GapChip from 'features/gap-components/status-chip/GapChip'

export interface IntegrationCapabilityRowProps {
   id: string
   icon: React.ReactNode
   label?: string
   description: string
   badge?: { label: string; colorVariant: React.ComponentProps<typeof GapChip>['colorVariant'] }
   action?: React.ReactNode
}

/** One line of what an integration can do: icon, label, description, optional badge and trailing action. */
export default observer(function IntegrationCapabilityRow(props: IntegrationCapabilityRowProps) {
   return <Stack direction="row" alignItems="center" spacing={1} sx={{ minHeight: 28 }}>
      <Box sx={{ display: 'flex', color: themeConfig.primary[600], '& svg': { fontSize: 20 } }}>{props.icon}</Box>
      {props.label && <Typography variant="body2Bold">{props.label}</Typography>}
      <Typography variant="body2" sx={{ color: themeConfig.primary[600] }}>{props.description}</Typography>
      {props.badge && <GapChip colorVariant={props.badge.colorVariant} label={props.badge.label} />}
      {props.action && <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>{props.action}</Box>}
   </Stack>
})
